import Menu from '../model/Menu';
import Settings from '../model/Settings';
import Page from '../model/Page';
import axios from 'axios';
import Student from '../model/Student';
import Olympics from '../model/Olympics';
import Post from '../model/Post';

export async function getAllPages() {
	const pagesRes = await fetch(process.env.REACT_APP_API_URL + '/oo/pages');
	const data = await pagesRes.json();
	return Page.fromApiResponse(data);
}

export async function getAllPosts() {
	const pagesRes = await fetch(process.env.REACT_APP_API_URL + '/oo/posts');
	const data = await pagesRes.json();
	return Post.fromApiResponse(data);
}

export async function getSettings() {
	const settingsRes = await fetch(process.env.REACT_APP_API_URL + '/acf/v3/options/option?_embed');
	const data = await settingsRes.json();
	return Settings.fromApiResponse(data);
}

export const getMenu = async () => {
	const menuRes = await fetch(process.env.REACT_APP_API_URL + '/oo/menu?location=topbar');
	const data = await menuRes.json();
	return Menu.fromApiResponse(data);
};

export async function getPostsPerPage(perPage: number, page: number) {
	const postsRes = await fetch(process.env.REACT_APP_API_URL + '/oo/posts-list?per_page=' + perPage + '&page=' + page);
	return await postsRes.json();
}

export async function getAnnouncementsPerPage(perPage: number, page: number) {
	const announcementsRes = await fetch(
		process.env.REACT_APP_API_URL + '/oo/announcements?per_page=' + perPage + '&page=' + page,
	);
	return await announcementsRes.json();
}

export const getAllDistricts = async (token?: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/districts' : '';
	const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
	return await axios.get(url, config);
};

export const getAllSchools = async (token?: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/schools' : '';
	const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
	return await axios.get(url, config);
};

export const addSchool = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/schools' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, data, config);
};

export const updateSchool = async (token: string | null, schoolId: number, data: any) => {
	const url = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/olympics/schools/${schoolId}` : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const addDistrict = async (token: string | null, data: { name: string }) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/districts' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, data, config);
};

export const addAdditionalStudent = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/registration/students/additional' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, data, config);
};

export const updateStudent = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/data-update' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const getAllTeachers = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/teachers/all' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const sendTeacherApproval = async (token: string | null, teacherId: number | undefined) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/teachers/approve' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { teacherId }, config);
};

export const sendTeacherDisApproval = async (token: string | null, teacherId: number | undefined) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/teachers/disapprove' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { teacherId }, config);
};

export const getAllStudents = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/all' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const updateFirstStageResult = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/first-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const updateSecondAStageResult = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/second-a-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const updateSecondBStageResult = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/second-b-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const updateSecondBStageDescription = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/students/second-b-stage-description'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const updateThirdAStageResult = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/third-a-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const updateThirdAWorkStatus = async (
	token: string | null,
	data: { student_id: number; status: string | null },
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/third-a-work-status' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const updateThirdBStageResult = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/third-b-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const getFirstStageStudents = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/first-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const getSecondAStageStudents = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/second-a-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const getSecondBStageStudents = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/second-b-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const getThirdAStageStudents = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/third-a-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const getThirdBStageStudents = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/third-b-stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

/** Admin: lista finałowa (sort: suma etapu III malejąco), gdy opublikowane IIIA. */
export const getStageIiiFinalRanking = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/stage-iii-final-ranking' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const getTeacherData = async (token: string | null, teacherId: number | null) => {
	const params = teacherId ? `?teacherId=${teacherId}` : '';
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/teachers/data' + params : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const updateTeacherData = async (token: string | null, data: any) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/teachers/update' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const getApprovedTeachers = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/teachers/filter' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const sendStudentUpdate = async (token: string | null, student?: Student | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/students/update' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	const requestBody = {
		id: student?.id,
		approved: student?.approved,
		teachersIds: student?.teachers ? student?.teachers.map((t) => t.id) : [],
	};
	return await axios.put(url, requestBody, config);
};

export const getOlympicsSettings = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/settings' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const getOlympicsEditions = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/editions' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const setWorkingOlympicsEdition = async (token: string | null, olympicsId: number | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/working-edition' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { olympicsId }, config);
};

export const getRegistrationSettings = async () => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/registration-settings' : '';
	return await axios.get(url);
};

export const updateOlympicsSettings = async (token: string | null, data: Olympics) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/settings' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

/** Przeliczenie final_title na kontach uczestników (jawne wywołanie, np. po zapisie progów z listy finałowej). */
export const recalculateOlympicsFinalTitles = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/recalculate-final-titles' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post<{ updated: number; skipped?: boolean; message?: string }>(url, {}, config);
};

export const updateOlympicsTopics = async (
	token: string | null,
	data: {
		type: 'oral' | 'linguistic';
		specializationId?: number | null;
		topics: { id?: number | null; topic: string; category: string }[];
	},
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/topics' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	const payload: any = {
		type: data.type,
		topics: data.topics,
	};
	if (data.specializationId) {
		payload.specialization_id = data.specializationId;
	}
	return await axios.put(url, payload, config);
};

export const updateOlympicsDeclarations = async (
	token: string | null,
	data: { declarations: { id?: number | null; declaration: string; required: boolean; short_title?: string | null }[] },
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/declarations' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, data, config);
};

export const getSurveyStats = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/survey-stats' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const publishStage = async (token: string | null, stage: number) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, { stage }, config);
};

export const publishSecondBQualification = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/second-b-qualification' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, {}, config);
};

export const recalculateSecondBQualification = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/students/second-b-qualification/recalculate'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, {}, config);
};

export const downloadReport = async (token: string | null, type: string, params?: Record<string, string | number>) => {
	const query = new URLSearchParams();
	query.set('type', type);
	if (params) {
		Object.entries(params).forEach(([key, value]) => {
			query.set(key, String(value));
		});
	}
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/report?${query.toString()}`
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
		responseType: 'blob',
	};
	// @ts-ignore
	return await axios.get(url, config);
};

export const generateStage3WorkCodes = async (token: string | null, regenerate: boolean = false) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-work-codes/generate'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { regenerate }, config);
};

export const getStage3CodePrintPresets = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-code-print-presets'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const saveStage3CodePrintPreset = async (
	token: string | null,
	payload: { slug: string; label: string; config: Record<string, any>; set_as_default?: boolean },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-code-print-presets'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const setStage3CodePrintDefaultPreset = async (token: string | null, slug: string) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-code-print-presets/default'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { slug }, config);
};

export const regenerateStage3WorkCode = async (token: string | null, studentId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-work-codes/regenerate'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { student_id: studentId }, config);
};

export const setStage3WorkCode = async (token: string | null, studentId: number, workCode: string) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-work-codes/set' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { student_id: studentId, work_code: workCode }, config);
};

export const getStage3JuryPairs = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-jury-pairs' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const createStage3JuryPair = async (token: string | null, payload: Record<string, any>) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-jury-pairs' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const updateStage3JuryPair = async (token: string | null, pairId: number, payload: Record<string, any>) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-jury-pairs/${pairId}`
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, payload, config);
};

export const deleteStage3JuryPair = async (token: string | null, pairId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-jury-pairs/${pairId}`
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.delete(url, config);
};

export const assignStage3JuryPairManual = async (
	token: string | null,
	payload: { student_id: number; jury_pair_id: number | null },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-jury-assignments/manual'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const autoAssignStage3JuryPairs = async (
	token: string | null,
	mode: 'unassigned_only' | 'unassigned_received' | 'assigned_without_received' = 'unassigned_only',
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-jury-assignments/auto'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { mode }, config);
};

export const getStage3DriveCoverage = async (
	token: string | null,
	payload: { files_by_district: Record<string, string[]> },
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/coverage' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const getStage3DriveCopyDryRun = async (
	token: string | null,
	payload: { files_by_district: Record<string, string[]> },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/copy-dry-run'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const getStage3DriveSetup = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/setup' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

export const saveStage3DriveSetup = async (
	token: string | null,
	payload: {
		access_token?: string;
		refresh_token?: string;
		client_id?: string;
		client_secret?: string;
		secretaries_parent_folder_url?: string;
		jury_parent_folder_url?: string;
		secretary_settings?: any[];
	},
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/setup' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.put(url, payload, config);
};

export const runStage3DriveHealthCheck = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/health-check'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, {}, config);
};

export const verifyStage3DriveSecretaries = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/verify-secretaries'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, {}, config);
};

export const verifyStage3DriveJuryFolders = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/verify-jury-folders'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, {}, config);
};

export const getStage3DriveCopyCandidates = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/copy-candidates'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, {}, config);
};

export const runStage3DriveCopy = async (
	token: string | null,
	payload: {
		items: Array<{
			student_id: number;
			work_code: string;
			source_file_id: string;
			source_file_name: string;
			target_folder_id: string;
			district_id: number;
			jury_pair_id: number;
		}>;
	},
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/copy-run' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const searchStage3DriveFolderFiles = async (
	token: string | null,
	payload: { base_folder_id: string; query?: string; limit?: number },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-tools/drive-folder-files'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const rotateStage3RawDriveFile = async (
	token: string | null,
	payload: {
		drive_file_id?: string;
		file_index_id?: number;
		page_rotations?: Record<number, number>;
		rotate_pages?: number[];
		target_folder_id?: string;
		output_name?: string;
		replace_current?: boolean;
	},
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-tools/raw-rotate' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const mergeStage3DrivePages = async (
	token: string | null,
	payload: {
		items: Array<{ drive_file_id: string; page: number }>;
		target_folder_id?: string;
		output_name?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-tools/merge-pages' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const replaceStage3DrivePages = async (
	token: string | null,
	payload: {
		base_drive_file_id: string;
		replacements: Array<{ target_page: number; source_drive_file_id: string; source_page: number }>;
		target_folder_id?: string;
		output_name?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-tools/replace-pages'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const markStage3AutoScanOkStudent = async (token: string | null, studentId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/autoskanok/student'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { student_id: studentId }, config);
};

export const markStage3AutoScanOkDistrict = async (token: string | null, districtId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/autoskanok/district'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { district_id: districtId }, config);
};

export const createStage3SecretaryFolders = async (
	token: string | null,
	payload: {
		parent_folder_url?: string;
		share_message?: string;
		send_notification_email?: boolean;
		overwrite_existing?: boolean;
		share_system_email?: boolean;
		share_secondary_email?: boolean;
		test_recipient_email?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/create-secretary-folders'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const createStage3SecretaryFoldersOnly = async (
	token: string | null,
	payload: {
		parent_folder_url?: string;
		overwrite_existing?: boolean;
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/create-secretary-folders-only'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const verifyStage3SecretaryFoldersOnly = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/verify-secretary-folders-only'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, {}, config);
};

export const shareStage3SecretaryFoldersOnly = async (
	token: string | null,
	payload: {
		share_message?: string;
		send_notification_email?: boolean;
		share_system_email?: boolean;
		share_secondary_email?: boolean;
		test_recipient_email?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/share-secretary-folders-only'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const createStage3JuryFolders = async (
	token: string | null,
	payload: {
		parent_folder_url?: string;
		share_message?: string;
		send_notification_email?: boolean;
		overwrite_existing?: boolean;
		test_recipient_email?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/create-jury-folders'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const createStage3JuryFoldersOnly = async (
	token: string | null,
	payload: {
		parent_folder_url?: string;
		overwrite_existing?: boolean;
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/create-jury-folders-only'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const verifyStage3JuryFoldersOnly = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/verify-jury-folders-only'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, {}, config);
};

export const shareStage3JuryFoldersOnly = async (
	token: string | null,
	payload: {
		share_message?: string;
		send_notification_email?: boolean;
		test_recipient_email?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-drive/share-jury-folders-only'
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, payload, config);
};

export const scanStage3FileIndex = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-file-index/scan' : '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const getStage3FileIndex = async (token: string | null, params: Record<string, any> = {}) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-file-index' : '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
		params,
	});
};

export const setStage3FileStatus = async (
	token: string | null,
	fileIndexId: number,
	payload: { status: string; reason?: string },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/status`
		: '';
	return await axios.patch(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const setStage3FileCategory = async (
	token: string | null,
	fileIndexId: number,
	payload: { category: string },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/category`
		: '';
	return await axios.patch(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const getStage3SplitPreview = async (
	token: string | null,
	fileIndexId: number,
	options?: { remove_points?: boolean; remove_work_code?: boolean; strip_terms?: string[] },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/split-preview`
		: '';
	return await axios.post(
		url,
		{
			remove_points: Boolean(options?.remove_points),
			remove_work_code: Boolean(options?.remove_work_code),
			strip_terms: options?.strip_terms || [],
		},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const splitStage3CombinedReview = async (
	token: string | null,
	fileIndexId: number,
	juryPairId: number,
	options?: {
		auto_assign?: boolean;
		assign_mode?: 'review_1' | 'review_2' | 'shared';
		selected_segment_ids?: number[];
		remove_points?: boolean;
		remove_work_code?: boolean;
		strip_terms?: string[];
	},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/split`
		: '';
	return await axios.post(
		url,
		{
			jury_pair_id: juryPairId,
			auto_assign: Boolean(options?.auto_assign),
			assign_mode: options?.assign_mode || 'review_1',
			selected_segment_ids: options?.selected_segment_ids || [],
			remove_points: Boolean(options?.remove_points),
			remove_work_code: Boolean(options?.remove_work_code),
			strip_terms: options?.strip_terms || [],
		},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const createStage3ImportCopy = async (token: string | null, fileIndexId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/import-copy`
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const setStage3JurorPointsByWorkCode = async (
	token: string | null,
	payload: { work_code: string; juror_slot: 'review_1' | 'review_2'; points: number | null },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/juror-points'
		: '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const exportStage3CommentsPdf = async (token: string | null, fileIndexId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/export-pdf`
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const getStage3FileComments = async (token: string | null, fileIndexId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/comments`
		: '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const getStage3Documents = async (token: string | null, params: Record<string, any> = {}) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-documents' : '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
		params,
	});
};

export const linkStage3Document = async (
	token: string | null,
	payload: {
		student_id: number;
		document_type: string;
		file_index_id?: number;
		drive_file_id?: string;
		page_range?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/link' : '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const deleteStage3Document = async (token: string | null, documentId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-documents/${documentId}`
		: '';
	return await axios.delete(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const updateStage3Document = async (
	token: string | null,
	documentId: number,
	payload: { document_type?: string; page_range?: string; notes?: string },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-documents/${documentId}`
		: '';
	return await axios.patch(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const rotateStage3DocumentCopy = async (
	token: string | null,
	documentId: number,
	payload: { rotate_pages: number[]; replace_current?: boolean },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-documents/${documentId}/rotate-copy`
		: '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const rotateStage3FileIndexCopy = async (
	token: string | null,
	fileIndexId: number,
	payload: { page_rotations?: Record<number, number>; rotate_pages?: number[]; replace_current?: boolean },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-file-index/${fileIndexId}/rotate-copy`
		: '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const bulkLinkStage3FileIndex = async (
	token: string | null,
	payload: { file_index_ids: number[]; document_type: string },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-file-index/bulk-link'
		: '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const setStage3SharedReview = async (token: string | null, studentId: number, sharedReview: boolean) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/shared-review'
		: '';
	return await axios.post(
		url,
		{ student_id: studentId, shared_review: sharedReview },
		{ headers: { Authorization: `Bearer ${token}` } },
	);
};

export const getStage3Completeness = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/completeness'
		: '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const verifyStage3DocumentLinks = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/verify-links'
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const resolveStage3StudentByWorkCode = async (token: string | null, workCode: string) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/resolve-student'
		: '';
	return await axios.post(
		url,
		{ work_code: workCode },
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const resolveStage3StudentLookup = async (token: string | null, query: string) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/resolve-student-lookup'
		: '';
	return await axios.post(
		url,
		{ query },
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const getStage3AccessRequests = async (token: string | null, params: Record<string, any> = {}) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-access-requests' : '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
		params,
	});
};

export const createStage3AccessRequestAdmin = async (
	token: string | null,
	payload: { student_id: number; request_channel?: string },
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-access-requests' : '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const updateStage3AccessRequest = async (
	token: string | null,
	requestId: number,
	payload: { status: string },
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-access-requests/${requestId}`
		: '';
	return await axios.patch(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const confirmStage3AccessRequest = async (token: string | null, requestId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-access-requests/${requestId}/confirm`
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const sendStage3Invitation = async (
	token: string | null,
	requestId: number,
	payload: { invitation_hours?: number } = {},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-access-requests/${requestId}/send-invitation`
		: '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const resendStage3Invitation = async (token: string | null, requestId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-access-requests/${requestId}/resend-invitation`
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const grantStage3Access = async (
	token: string | null,
	requestId: number,
	payload: { durationMinutes?: number } = {},
) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-access-requests/${requestId}/grant`
		: '';
	return await axios.post(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const revokeStage3Access = async (token: string | null, requestId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-access-requests/${requestId}/revoke`
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const expireStage3Invitations = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-access-requests/expire-invitations'
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const getStage3DocSettings = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-doc-settings' : '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const saveStage3DocSettings = async (
	token: string | null,
	payload: {
		invitation_hours?: number;
		access_minutes?: number;
		watermark_template?: string;
		view_enabled?: boolean;
		request_enabled?: boolean;
		ready_mail_subject?: string;
		ready_mail_body?: string;
	},
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/stage3-doc-settings' : '';
	return await axios.put(url, payload, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const setStage3CompletenessVerified = async (token: string | null, studentId: number, verified: boolean) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/completeness/verify'
		: '';
	return await axios.post(
		url,
		{ student_id: studentId, verified },
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const setStage3CompletenessAutoAccess = async (token: string | null, studentId: number, disabled: boolean) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/stage3-documents/completeness/auto-access'
		: '';
	return await axios.post(
		url,
		{ student_id: studentId, disabled },
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const createMyStage3AccessRequest = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/students/me/access-request'
		: '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const getMyStage3AccessStatus = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/students/me/access-status'
		: '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const openMyStage3Access = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/students/me/open-access' : '';
	return await axios.post(
		url,
		{},
		{
			headers: { Authorization: `Bearer ${token}` },
		},
	);
};

export const getMyStage3DocumentStreamUrl = (documentId: number): string =>
	process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/students/me/documents/${documentId}/stream`
		: '';

export const getMyStage3DocumentComments = async (token: string | null, documentId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/students/me/documents/${documentId}/comments`
		: '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const getStage3DocumentAdminStreamUrl = (documentId: number): string =>
	process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-documents/${documentId}/stream`
		: '';

export const getStage3DocumentCommentsAdmin = async (token: string | null, documentId: number) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/olympics/stage3-documents/${documentId}/comments`
		: '';
	return await axios.get(url, {
		headers: { Authorization: `Bearer ${token}` },
	});
};

export const getNewEditionToken = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/new-edition-token' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};

/** @deprecated Prefer getNewEditionToken — alias kompatybilności */
export const getResetToken = getNewEditionToken;

export const createNewEdition = async (token: string | null, confirmationToken: string | null) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/new-edition' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, { confirmationToken }, config);
};

/** @deprecated Prefer createNewEdition — alias kompatybilności */
export const resetOlympics = createNewEdition;

export type SchoolsRspoDiffRow = {
	type: 'new' | 'changed' | 'manual_skip' | 'missing_from_rspo';
	rspo: number;
	local_name: string;
	remote_name: string;
	local_city: string;
	remote_city: string;
	local_zip: string;
	remote_zip: string;
	local_street?: string;
	remote_street?: string;
	local_building?: string;
	remote_building?: string;
	local_apartment?: string;
	remote_apartment?: string;
	manually_edited?: boolean;
	/** Klucze pól (CSV / techniczne). */
	fields?: string;
	/** Polskie etykiety pól z różnicą, np. „ulica, budynek”. */
	fields_labels?: string;
	/** Domyślna akcja (np. skip gdy lokalna nazwa ma dopisek „w miasto”). */
	default_action?: 'add' | 'apply' | 'skip' | 'remove';
	/** true gdy uczeń wybrał tę szkołę (RSPO) w poprzedniej lub bieżącej edycji. */
	student_used_in_prior_edition?: boolean;
};

export type SchoolsRspoDiffReport = {
	summary: {
		olympics_id: number;
		previous_olympics_id: number | null;
		previous_edition: number | null;
		county_filter: string | null;
		voivodeship_filter?: string | null;
		new_from_rspo: number;
		changed: number;
		manual_skipped: number;
		/** Wiersze z domyślną akcją Pomiń (ręczne, muzyczne, uczeń z poprzedniej edycji, dopisek „w miasto” itd.). */
		default_skipped?: number;
		missing_from_rspo?: number;
		/** Placówki z uczniami > 0 (kandydaci do add/update). */
		total_rspo: number;
		/** Niezlikwidowane w API (w tym uczniowie = 0) — baza do „Brak w rejestrze”. */
		total_rspo_present?: number;
		/** live = api.rspo.gov.pl; fixture = lokalny stub (E2E / awaria). */
		source?: 'live' | 'fixture';
		cache_hit?: boolean;
		fetched_at?: number | null;
	};
	rows: SchoolsRspoDiffRow[];
};

export type SchoolsRspoScope = {
	county?: string;
	voivodeship?: string;
	refresh?: boolean;
};

export const getSchoolsRspoDiff = async (token: string | null, scope?: SchoolsRspoScope) => {
	const base = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/schools/rspo-diff' : '';
	const params = new URLSearchParams();
	if (scope?.county) params.set('county', scope.county);
	if (scope?.voivodeship) params.set('voivodeship', scope.voivodeship);
	if (scope?.refresh) params.set('refresh', '1');
	const qs = params.toString();
	const url = qs ? `${base}?${qs}` : base;
	const config = { headers: { Authorization: `Bearer ${token}` } };
	const res = await axios.get<SchoolsRspoDiffReport>(url, config);
	return res.data;
};

export const applySchoolsRspoDecisions = async (
	token: string | null,
	decisions: { rspo: number; action: 'add' | 'apply' | 'skip' | 'remove' }[],
	scope?: SchoolsRspoScope,
) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/olympics/schools/rspo-apply' : '';
	const config = { headers: { Authorization: `Bearer ${token}` } };
	const res = await axios.post(
		url,
		{
			decisions,
			county: scope?.county || '',
			voivodeship: scope?.voivodeship || '',
		},
		config,
	);
	return res.data as { applied: number; skipped: number };
};

/** Przywraca okręgi szkół z poprzedniej edycji (po RSPO); Mazowsze → I/II po ZIP. */
export const restoreSchoolDistrictsFromPreviousEdition = async (token: string | null) => {
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + '/olympics/schools/restore-districts-from-previous-edition'
		: '';
	const config = { headers: { Authorization: `Bearer ${token}` } };
	const res = await axios.post(url, {}, config);
	return res.data as {
		message: string;
		updated: number;
		skipped: number;
		total: number;
		olympics_id: number;
		previous_olympics_id?: number | null;
	};
};

export const createCertificates = async (token: string | null, data: { type: string }) => {
	const url = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL + '/certificates/create' : '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.post(url, data, config);
};

export const getStageStatistics = async (
	token: string | null,
	stage: string = 'first',
	includePointsDistribution: boolean = false,
	includeTopicsAnalysis: boolean = false,
) => {
	const params = new URLSearchParams();
	params.append('stage', stage);
	if (includePointsDistribution) {
		params.append('points_distribution', 'true');
	}
	if (includeTopicsAnalysis) {
		params.append('topics_analysis', 'true');
	}
	const url = process.env.REACT_APP_API_URL
		? process.env.REACT_APP_API_URL + `/students/stage-statistics?${params.toString()}`
		: '';
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	return await axios.get(url, config);
};
